<template>
  <div v-if="editMode || dgRowInEditMode[gridId + '.' + rowKey]">
    <div
      class="data-grid__lookUpWrapper"
      :class="{ _hasAddVal: controlInfo.ableToAddLookUpVal && !controlInfo.readonly }"
    >
      <multiselect
        v-model="selectedLookUps"
        :options="lookups"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
        placeholder
        selectLabel
        selectedLabel
        tagPlaceholder
        deselectLabel
        label="text"
        track-by="value"
        @select="save"
        @remove="save"
        :disabled="controlInfo.readonly"
        openDirection="bottom"
        ref="select"
        @open="adjustDropdown"
        @close="releaseDropdown"
      />
      <a
        href="#"
        v-if="controlInfo.ableToAddLookUpVal && !controlInfo.readonly"
        class="data-grid__lookupAddVal"
        @click.prevent="showLookUpModal"
      >
        <icon name="plus" />
      </a>
    </div>
  </div>
  <div v-else>
    <div v-if="cellDisplayVal">
      <b-badge
        v-for="(lookup, key) in cellDisplayVal"
        :key="key"
        href="#"
        pill
        variant="primary"
        style="margin-right: 3px;"
        @click.prevent="openLookUpRow(key)"
      >{{ lookup }}</b-badge>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { find, debounce } from 'lodash'
// services
import db from '@/services/db'

export default {
  props: [
    'rowKey',
    'cellKey',
    'cellVal',
    'cellDisplayVal',
    'options',
    'editMode',
    'gridId',
    'controlInfo',
  ],
  data() {
    return {
      selectedLookUps: [],
      debounced: null,
    }
  },
  watch: {
    cellVal() {
      this.setLookUpVal()
    },
    lookups() {
      this.setLookUpVal()
    },
  },
  computed: {
    ...mapState(['dataGrid_options', 'dgRowInEditMode']),
    lookUpTable() {
      return this.options.meta[this.cellKey].lookUpTable
    },
    lookUpTableDisplayColumn() {
      return this.dataGrid_options[this.lookUpTable].displayColumn
    },
    lookups() {
      const lookups = []
      const lookUpTableVals = $getGrid(this.lookUpTable)

      if (lookUpTableVals) {
        lookUpTableVals.map(row => {
          lookups.push({
            text: row[this.lookUpTableDisplayColumn],
            value: row.rowKey,
          })
        })
      }

      return lookups
    },
  },
  methods: {
    setLookUpVal() {
      if (this.debounced) {
        this.debounced()
        return
      } else {
        this.debounced = debounce(() => {
          this.selectedLookUps = []

          if (!this.cellVal) return

          const values = this.cellVal.split(',')

          for (let value of values) {
            const lookup = find(this.lookups, { value })

            if (lookup) {
              this.selectedLookUps.push(lookup)
            } else {
              console.error(
                `[multi_lookup] - row "${value}" not found in "${this.lookUpTable}" grid`
              )
            }
          }
        }, 500)
      }

      this.debounced()
    },
    save() {
      this.$nextTick(() => {
        if (this.debounced) this.debounced.cancel()

        const value = this.selectedLookUps.length
          ? this.selectedLookUps.map(item => item.value).join(',')
          : null

        const data = {
          options: this.options,
          rowKey: this.rowKey,
          cellKey: this.cellKey,
          value,
        }

        if (this.options.isReactive || typeof this.options.isReactive === 'undefined') {
          db.dataGrid.data.saveCellVal(data)
        } else {
          const rowInst = this.$instByClass(this, 'data-grid__row')

          rowInst.rowData[this.cellKey] = value
        }
      })
    },
    showLookUpModal() {
      $dgAddRow(this.lookUpTable).then(rowKey => {
        $dgShowEditRowModal(this.lookUpTable, rowKey)
        this.selectedLookUps.push({ text: '', value: rowKey })
        this.save()
      })
    },
    openLookUpRow(rowKey) {
      $dgShowEditRowModal(this.lookUpTable, rowKey)
    },
    adjustDropdown() {
      this.$multiselect_adjustDropdown.bind(this)()
    },
    releaseDropdown() {
      this.$multiselect_releaseDropdown.bind(this)()
    },
  },
  created() {
    this.setLookUpVal()
  },
  beforeDestroy() {
    this.selectedLookUps = null
    this.debounced = null
  },
}
</script>

<style lang="scss">
.data-grid .data-grid {
  &__cell._lookup {
    min-width: 250px;
    padding: 0;
  }
}
.data-grid {
  &__lookUpWrapper {
    &._hasAddVal {
      position: relative;
      padding-right: 40px;
      .data-grid__lookupAddVal {
        position: absolute;
        right: 10px;
        bottom: 11px;
      }
    }
  }
}
</style>
